import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { FilesInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { extname } from 'path';
import { diskStorage } from 'multer';
import { imageFileFilter } from '../shared/file-upload';
import { ComplaintService } from './complaint.service';
import { ChangeStatusDTO, ComplaintDelDTO, ComplaintDTO, CTypeDTO, DelTypeDTO } from './dto/complaint.dto';
import { AllComplaintResponseModel, ComplaintResponseModel, SignalComplaintResponseModel } from './complaint-response-module';
@ApiTags('Complaints')
@Controller('complaint')
export class ComplaintController {
    constructor (
        private cService: ComplaintService,
    ){}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createType') 
    @ApiQuery({name:'apiVersion'})   
    @UseInterceptors(
		FilesInterceptor('attachments', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/complaintImages',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async createCType(@Query() queryParam,@UploadedFiles() attachments,@Body() typeDto:CTypeDTO,@Req() request:Request): Promise<ComplaintResponseModel> {
        try {
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {                   
                    attachmentsUrl: `complaint/complaintImages/${file.filename}`
                };
                response.push(fileReponse);
            })
            return await this.cService.createCType(queryParam, response,typeDto);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateType') 
    @ApiQuery({name:'apiVersion'})   
    @UseInterceptors(
		FilesInterceptor('attachments', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/complaintImages',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async updateCType(@Query() queryParam,@UploadedFiles() attachments,@Body() typeDto:CTypeDTO,@Req() request:Request): Promise<ComplaintResponseModel> {
        try {
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {                   
                    attachmentsUrl: `complaint/complaintImages/${file.filename}`,
                };
                response.push(fileReponse);
            })
            return await this.cService.updateCType(queryParam, response,typeDto);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getTypes')
    @ApiQuery({name:'apiVersion'})
    async getTypes(@Query() queryParams, @Req() request:Request):Promise<AllComplaintResponseModel> {
        try {           
            return await this.cService.getTypes(queryParams,request);
        } catch (error) {
            return errorHandler(AllComplaintResponseModel, error);
        }
    }

    @Get('complaintImages/:imgpath')
    @ApiParam({name:'imgpath'})
    seeUploadedFile(@Param('imgpath') attachments, @Res() res) {
		try {
            return res.sendFile(attachments, { root: './public/complaintImages' });
		} catch (error) {
			return error.message;
		}
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/deleteType')
    @ApiQuery({name:'apiVersion'})
    async DeleteType(@Query() queryParams, @Body() delDto:DelTypeDTO, @Req() request: Request): Promise<ComplaintResponseModel> {
        try {   
            return await this.cService.DeleteType(queryParams,delDto, request);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    }


    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createComplaint') 
    @ApiQuery({name:'apiVersion'})   
    @UseInterceptors(
		FilesInterceptor('attachments', 5, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/userComplaintImages',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async createComplaint(@Query() queryParam,@UploadedFiles() attachments,@Body() cDto:ComplaintDTO,@Req() request:Request): Promise<ComplaintResponseModel> {
        try {
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {                   
                    attachmentsUrl: `complaint/userComplaintImages/${file.filename}`
                };
                response.push(fileReponse);
            })
            return await this.cService.createComplaint(queryParam, response,cDto);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateComplaint') 
    @ApiQuery({name:'apiVersion'})   
    @UseInterceptors(
		FilesInterceptor('attachments', 5, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/userComplaintImages',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async updateComplaint(@Query() queryParam,@UploadedFiles() attachments,@Body() cDto:ComplaintDTO,@Req() request:Request): Promise<ComplaintResponseModel> {
        try {
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {  
                    complaintId:cDto.Id,                 
                    attachmentsUrl: `complaint/userComplaintImages/${file.filename}`,
                };
                response.push(fileReponse);
            })
            return await this.cService.updateComplaint(queryParam, response,cDto);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getComplaints/:userId')
    @ApiOperation({summary:'get list with filter - query param type means is it a all complaints = 0, Yet to start = 1 , In progress  = 2, Completed =3'})
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'skip'})
    @ApiQuery({name:'type'})
    @ApiParam({name:'userId'})
    async getComplaints(@Query() queryParams,@Param('userId') userId, @Req() request:Request):Promise<AllComplaintResponseModel> {
        try {           
            return await this.cService.getComplaints(queryParams,userId,request);
        } catch (error) {
            return errorHandler(AllComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getComplaintById/:Id')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Id'})
    async getComplaintById(@Query() queryParams,@Param('Id') Id, @Req() request:Request):Promise<SignalComplaintResponseModel> {
        try {
            return await this.cService.getComplaintById(queryParams,Id,request);
        } catch (error) {
            return errorHandler(SignalComplaintResponseModel, error);
        }
    }

    @Get('userComplaintImages/:imgpath')
    @ApiParam({name:'imgpath'})
    seeUploadedComFile(@Param('imgpath') attachments, @Res() res) {
		try {
            return res.sendFile(attachments, { root: './public/userComplaintImages' });
		} catch (error) {
			return error.message;
		}
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateComplaintStatus')
    @ApiQuery({name:'apiVersion'})
    async updateComplaintStatus(@Query() queryParams, @Body() changeDto: ChangeStatusDTO, @Req() request: Request): Promise<ComplaintResponseModel> {
        try {   
            return await this.cService.updateComplaintStatus(queryParams,changeDto, request);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    } 
    
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getComplaintStatus/:userId')
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'skip'})
    @ApiParam({name:'userId'})
    async getComplaintStatus(@Query() queryParams,@Param('userId') userId, @Req() request:Request):Promise<AllComplaintResponseModel> {
        try {           
            return await this.cService.getComplaintStatus(queryParams,userId,request);
        } catch (error) {
            return errorHandler(AllComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getComplaintDetailedStatus/:Id')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Id'})
    async getComplaintDetailedStatus(@Query() queryParams,@Param('Id') Id, @Req() request:Request):Promise<AllComplaintResponseModel> {
        try {           
            return await this.cService.getComplaintDetailedStatus(queryParams,Id,request);
        } catch (error) {
            return errorHandler(AllComplaintResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/deleteComplaint')
    @ApiQuery({name:'apiVersion'})
    async deleteComplaint(@Query() queryParams, @Body() delDto: ComplaintDelDTO, @Req() request: Request): Promise<ComplaintResponseModel> {
        try {   
            return await this.cService.deleteComplaint(queryParams,delDto, request);
        } catch (error) {
            return errorHandler(ComplaintResponseModel, error);
        }
    }
}
